import { gql } from '@apollo/client';

const SEARCH_USER_BY_EMAIL = gql`
  query SearchUserByEmail($email: String!) {
    searchUserByEmail(email: $email) {
      ExternalUserId
      FirstName
      LastName
      Email
    }
  }
`;

export default SEARCH_USER_BY_EMAIL;
